import React,{ Component } from 'react';
import { viewData } from '../../../core/HttpAction';
import { Link } from 'react-router-dom';

const courseUrl='/getallcourse';
const courseYearUrl='/getallcourse-year';

class Filter extends Component {
    constructor(props) {
        super(props);
        this.state={ 
            course_id:'',
            course_year_id:'',
            courseData:[],
            course_quota:'',
            other_scholarship:'',
            graduation:'', 
            courseYearData:[],
        }; 
    }

    componentDidMount(){
        viewData(courseUrl).then((res)=>{
            if(res.data.status===200){
                let datams =res.data.data;

                this.setState({courseData:datams});
            }
        });
    }

    getCourseYearData(id){
        viewData(courseYearUrl+'/'+id).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
                this.setState({courseYearData:datam}); 
            }
        });
    }

    setStateFromInput=(event)=> {
        const { props } =this.props;
        event.preventDefault();
        var obj = {};
        obj[event.target.name] = event.target.value;
        if(event.target.name=='course_id'){
            this.getCourseYearData(event.target.value);
        }
        this.setState(obj,()=>{
            const {course_id,course_quota,course_year_id,other_scholarship,graduation} =this.state;
            props.custonAction({course_id,course_quota,course_year_id,other_scholarship,graduation});
        });
    }
 

    render() {
        const {courseData,course_id,courseYearData,course_year_id,course_quota,other_scholarship, graduation} =this.state; 
        const { addbtn }=this.props; 
        return (
            <div className="uk-grid" style={{padding:'8px 0 3px 0'}}>
                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'>
                        <select id="select_demo_1" className="md-input" name="course_id" onChange={this.setStateFromInput} value={course_id}>
                            <option value="0">Select Course</option>
                            {
                                courseData && courseData.map((val,i)=>{
                                    return(
                                        <option key={i} value={val.course_id} >{val.course_name}</option>
                                    );
                                })
                            } 
                        </select> 
                    </div>
                </div>
                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'>
                        <select id="select_demo_1" className="md-input" name="course_year_id" onChange={this.setStateFromInput} value={course_year_id}>
                            <option value="0">Select Course Year</option>
                            {
                                courseYearData && courseYearData.map((val,i)=>{
                                    return(
                                        <option key={i} value={val.course_year_id} >{val.year_name}</option>
                                    );
                                })
                            } 
                        </select> 
                    </div>
                </div>

                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'>
                        <select className="md-input" name="other_scholarship" value={other_scholarship} onChange={this.setStateFromInput} style={{width:'125px',float: 'left', marginRight:'8px'}} > 
                            <option value="">Select Other Scholarship</option>  
                            <option value="0">No</option>  
                            <option value="1">Yes</option> 
                        </select> 
                    </div>
                </div>
                  
                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'>
                        <select className="md-input" name="graduation" value={graduation} onChange={this.setStateFromInput} style={{width:'125px',float: 'left', marginRight:'8px'}} > 
                            <option value="">Select First Graduation</option>  
                            <option value="0">No</option>  
                            <option value="1">Yes</option> 
                        </select> 
                    </div>
                </div>

                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'>
                        <select className="md-input" name="course_quota" value={course_quota} onChange={this.setStateFromInput} style={{width:'125px',float: 'left', marginRight:'8px'}} > 
                            <option value="">Select Quota</option>  
                            <option value="0">Government</option>  
                            <option value="1">Management</option> 
                        </select>  
                    </div>
                </div>  
                { addbtn && 
                <div className="uk-width-medium-1-6"> 
                    <div className='md-input-wrapper'> 
                        <Link style={{float:'left',marginLeft:'6px'}}to={`${addbtn}`}> <button type="button"  className="md-btn md-btn-primary md-btn-small md-btn-wave-light waves-effect waves-button waves-light">Add</button></Link>
                    </div>
                </div>  
                }
            </div>
        );
    }
}

export default Filter;





// WEBPACK FOOTER //
// ./src/components/Student/Student/Filter.js